import i18n from "i18next";
import { withTolgee, Tolgee, I18nextPlugin, DevTools } from "@tolgee/i18next";
import ICU from "i18next-icu";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  applyLanguageToDocument,
  getPersistedLanguage,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
} from "./utils/language";

import en from "./locales/en.json";
import ar from "./locales/ar.json";

const initialLanguage = getPersistedLanguage();

export const tolgee = Tolgee().use(DevTools()).use(I18nextPlugin()).init({
  apiUrl: window.env.TOLGEE_API_URL,
  apiKey: window.env.TOLGEE_API_KEY,
});

withTolgee(i18n, tolgee)
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { default: en },
      ar: { default: ar },
    },
    lng: initialLanguage,
    defaultNS: "default",
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    load: "languageOnly",
    detection: {
      order: ["localStorage", "htmlTag", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

applyLanguageToDocument(initialLanguage);

i18n.on("languageChanged", (lang) => {
  const normalizedLanguage = normalizeLanguage(lang);

  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
  }

  applyLanguageToDocument(normalizedLanguage);
});

export default i18n;
